import {
  Box,
  Card,
  Grid2 as Grid,
  styled,
  Typography,
  TypographyProps
} from '@mui/material'
import NavLinkBack from 'components/NavLinkBack'
import { PROFILE } from 'navigation/CONSTANTS'

const StyledParagraph = ({ variant = 'body1', ...props }: TypographyProps) => {
  return <Typography variant={variant} {...props} />
}

const StyledBoldParagraph = styled(StyledParagraph)(({ theme }) => ({
  fontWeight: 'bold'
}))

const StyledContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.action.selected,
  flex: 1,
  gap: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column'
}))

const sections = [
  {
    'Versão Comercial:': 'plataforma sentinela de monitoramento de saúde',
    'Registro ANVISA:': '81464750188',
    'Identificação do Produto:': 'Software Versão 1.0.0 – SaMD Classe II',
    'Validade:': 'Não aplicável',
    'Especificações e características técnicas, instruções de uso, advertências e precauções:':
      'Ler Manual do Usuário.',
    'Fabricante:': [
      'swissanalytica HealthInnovations GmbH',
      'Lindenhofweg 4, 8806 Bäch, Suíça',
      'E-mail: info@swissanalytica.ch'
    ],
    'Detentor do Registro:': [
      'Domo Salute Consultoria Regulatória Ltda.',
      'Avenida Cristóvão Colombo, 2948, Sala 411 - CEP 90540-072, Porto Alegre/RS - Brasil',
      'Responsável Técnico: Eng. Diego Louzada CREA/RS 162977'
    ]
  },
  {
    'Versão Comercial:': 'sentinela diagnósticos: módulo raio-x',
    'Registro ANVISA:': '81464750194',
    'Identificação do Produto:': 'Software Versão 1.0.0 – SaMD Classe II',
    'Validade:': 'Não aplicável',
    'Especificações e características técnicas, instruções de uso, advertências e precauções:':
      'Ler Manual do Usuário.',
    'Fabricante:': [
      'swissanalytica HealthInnovations GmbH',
      'Lindenhofweg 4, 8806 Bäch, Suíça',
      'E-mail: info@swissanalytica.ch'
    ],
    'Detentor do Registro:': [
      'Domo Salute Consultoria Regulatória Ltda.',
      'Avenida Cristóvão Colombo, 2948, Sala 411 - CEP 90540-072, Porto Alegre/RS - Brasil',
      'Responsável Técnico: Eng. Diego Louzada CREA/RS 162977'
    ]
  }
]

interface SectionProps {
  title: string
  children: React.ReactNode
  key?: string | number
}

const Section: React.FC<SectionProps> = ({ title, children, key }) => (
  <Grid key={key} size={12}>
    <StyledBoldParagraph>{title}</StyledBoldParagraph>
    {children}
  </Grid>
)

const LegalInformationPage: React.FC = () => {
  return (
    <Grid
      container
      spacing={2}
      p={2}
      margin='0 auto'
      width='100%'
      maxWidth={1200}
    >
      <Grid>
        <NavLinkBack to={`/${PROFILE}`} />
      </Grid>

      <Grid size={12} display='flex' justifyContent='space-between'>
        <Typography variant='h5'>Informações legais</Typography>
      </Grid>

      {sections.map((section, index) => (
        <Grid size={{ xs: 12, md: 6 }} key={'section' + index}>
          <StyledContent>
            {Object.entries(section).map(([key, value]) => (
              <Section title={key} key={key}>
                {Array.isArray(value) ? (
                  value.map((line, index) => (
                    <StyledParagraph key={`${key}-item-${index}`}>
                      {line}
                    </StyledParagraph>
                  ))
                ) : (
                  <StyledParagraph>{value}</StyledParagraph>
                )}
              </Section>
            ))}
          </StyledContent>
        </Grid>
      ))}
    </Grid>
  )
}

export default LegalInformationPage
